import script from "./CustomCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomCard.vue?vue&type=script&setup=true&lang=js"

import "./CustomCard.vue?vue&type=style&index=0&id=2211debc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2211debc"]])

export default __exports__